import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const initGSAPHeaderScroll = () => {

	const scrollers = document.querySelectorAll('.horizontal-scroll');

	if (!scrollers.length) return;

	scrollers.forEach((scroller) => {

		const sentence1 = scroller.querySelector('.sentence1 p');
		const sentence2 = scroller.querySelector('.sentence2 p');

		gsap.to(sentence1, {
			x: -sentence1.clientWidth / 2,
			ease: 'none',
			duration: 20,
			repeat: -1,
		})
		gsap.from(sentence2, {
			x: -sentence2.clientWidth / 2,
			ease: 'none',
			duration: 20,
			repeat: -1,
		})

		gsap.to([sentence1, sentence2], {
			yPercent: '-=100',
			ease: 'power1.inOut',
			scrollTrigger: {
				trigger: scroller,
				start: 'top 70%',
				end: 'bottom 50%',
				scrub: 2
			}
		});
	});

}

export { initGSAPHeaderScroll };